import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-bootstrap-date-picker';

class StaffsEmployerTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      employer_id: null,
      date_start: '',
      lista_empregadores: [],
      dados: [],
      modal: false,
    };
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarEmpregador = this.adicionarEmpregador.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.empregadores) && Array.isArray(newProps.lista_empregadores)) {
      this.setState({dados: newProps.empregadores, lista_empregadores: newProps.lista_empregadores});
    }
  }

  adicionarEmpregador(event) {
    event.preventDefault();
    var datasave = {
      employer_id: this.state.employer_id,
      staff_id: this.props.staff_id,
      date_start: this.state.date_start_str,
      type: 'empregador',
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alunos/empregadores', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_employer_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse empregador?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aluno/empregador/' + staff_employer_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_employer_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_employer_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == staff_employer_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar Empregadores</h3>
  <hr/>
    <form onSubmit={this.adicionarEmpregador}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Empregador:</label>
            <Select
              className="form-field-name"
              name="employer_id"
              value={this.state.employer_id}
              searchable={true}
              placeholder={'Selecionar Empregador'}
              onChange={this.handleSelectChange.bind(this, 'employer_id')}
              options={this.state.lista_empregadores}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Data de Início:</label>
            <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de início" value={this.state.date_start} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-plus"></i> Adicionar Empregador</button>
          </div>
        </div>
      </div>
    </form>  
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há Empregadors cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="empregador_nome" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Empregador</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffsEmployerTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsEmployerTab.js